import { render } from "./ConfirmationPaiementPage.vue?vue&type=template&id=70b4961a&ts=true"
import script from "./ConfirmationPaiementPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmationPaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__